import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IIdValue,
  IDialog,
  ILoginInformation,
  IBuild,
  IStartupConfig,
} from "../../app/types";

export interface IAppBar {
  companyTitle: IIdValue;
  companySubTitle: IIdValue;
  accountInfo: IIdValue;
  contactInfo: IDialog;
  loginInfo: ILoginInformation;
  buildData: IBuild;
  startupConfigs: IStartupConfig;
}

let initialState: IAppBar = {
  companyTitle: {
    id: "TITLE",
    value: "MIDRANGE DYNAMICS",
  },
  companySubTitle: {
    id: "SUBTITLE",
    value: "providing innovative IBM i solutions",
  },
  accountInfo: {
    id: "ACCOUNTINFO",
    value: ["Session Info", "Reload App", "Logoff"],
  },
  contactInfo: {
    header: "Contact",
    content: {
      title: "Contact Midrange Dynamics for Assistance",
      url: "https://support.mdcms.ch/login.jsp",
      details: {},
    },
  },
  loginInfo: { data: {}, headers: {} },
  buildData: {} as IBuild,
  startupConfigs: {} as IStartupConfig,
};

const appBarSlice = createSlice({
  name: "appBar",
  initialState,
  reducers: {
    resetAppBarState: () => initialState,
    setAppBarCompanyTitle(state, action: PayloadAction<IIdValue>) {
      state.companyTitle = action.payload;
    },
    setAppBarCompanySubTitle(state, action: PayloadAction<IIdValue>) {
      state.companySubTitle = action.payload;
    },
    setAppBarAccountInfo(state, action: PayloadAction<IIdValue>) {
      state.accountInfo = action.payload;
    },
    setAppBarContactInfo(state, action: PayloadAction<IDialog>) {
      state.contactInfo = action.payload;
    },
    setAppBarContactInfoDetails(state, action: PayloadAction<{}>) {
      if (state.contactInfo.content)
        state.contactInfo.content.details = action.payload;
    },
    setAppBarLoginInfo(state, action: PayloadAction<ILoginInformation>) {
      state.loginInfo = action.payload;
    },
    setAppBarBuild(state, action: PayloadAction<IBuild>) {
      state.buildData = action.payload;
    },
    setStartupConfigs(state, action: PayloadAction<IStartupConfig>) {
      state.startupConfigs = action.payload;
    },
  },
});

export const {
  resetAppBarState,
  setAppBarCompanyTitle,
  setAppBarCompanySubTitle,
  setAppBarAccountInfo,
  setAppBarContactInfo,
  setAppBarContactInfoDetails,
  setAppBarLoginInfo,
  setAppBarBuild,
  setStartupConfigs,
} = appBarSlice.actions;

export default appBarSlice.reducer;
